import { useAppDispatch, useAppSelector } from 'src/app/hooks';
import { Table } from 'src/components/Table/Table';
import { draftsTableColumns } from '../../utils/utils';
import styles from '../../pages/DashboardDraftsScreen/DashboardDraftsScreen.module.scss';

export const DashboardDrafts = () => {
  const drafts = useAppSelector((state) => state.dock.drafts);
  const dispatch = useAppDispatch();

  const savedDrafts = drafts.filter((draft) => draft.saved);

  const tableColumns = draftsTableColumns(dispatch);
  return (
    <div className={styles.table_container}>
      {savedDrafts.length ? (
        <Table columns={tableColumns} data={savedDrafts || []} />
      ) : (
        <h2>No posee borradores</h2>
      )}
    </div>
  );
};
